<div class="steps-container">
  <ng-content></ng-content>
</div>
